'use client';

import { useEffect } from 'react';

import { MIXPANEL_APP_FEATURES, mixpanelEvents } from '@/shared/constants/mixpanel-events';
import { useIdleIntercom } from '@/shared/hooks/use-intercom-widget';
import { emitMixpanelEvent } from '@/shared/utils/mixpanel-utils';

/** Client-only side effects for /switch: page-view event and Intercom. A null island. */
export const SwitchPageEffects = () => {
	useIdleIntercom();

	useEffect(() => {
		emitMixpanelEvent(mixpanelEvents.VIEWED_SWITCH_PAGE, {
			feature: MIXPANEL_APP_FEATURES.SWITCH_PAGE,
		});
	}, []);

	return null;
};
